"use client";

import { Link } from "@/components/common/Link";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const navigationLinks = [{
    label: "Home",
    href: "/HomePage"
  }, {
    label: "About",
    href: "/AboutPage"
  }, {
    label: "Services",
    href: "/ServicesPage"
  }, {
    label: "Contact",
    href: "/ContactPage"
  }];
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }];
  return <footer className="w-full bg-dark-background text-foreground-dark py-8 px-4 md:px-8 border-t border-border">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6 items-center">
        {}
        <div className="text-center md:text-left">
          <p className="text-sm text-foreground-dark/80">
            © {currentYear} AA Eagle Plumbing. All rights reserved.
          </p>
        </div>

        {}
        <nav className="flex justify-center items-center gap-4 flex-wrap">
          {navigationLinks.map((link, i) => <Link key={i} to={link.href} className="relative text-sm font-medium text-foreground-dark hover:text-accent transition-colors duration-[var(--duration-medium)] group">
              {link.label}
              <span className="absolute left-0 bottom-0 w-0 h-[2px] bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] group-hover:w-full" />
            </Link>)}
        </nav>

        {}
        <div className="flex justify-center md:justify-end items-center gap-4">
          {socialLinks.map((social, i) => {
          const Icon = social.icon;
          return <Link key={i} to={social.href} newTab aria-label={social.label} className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] hover:scale-105">
                <Icon className="size-5" />
              </Link>;
        })}
        </div>
      </div>
    </footer>;
}